import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function shortAddr(addr, head = 4, tail = 4) {
  if (!addr || typeof addr !== "string") return "";
  if (addr.length <= head + tail + 3) return addr;
  return `${addr.slice(0, head)}…${addr.slice(-tail)}`;
}

export function formatUSD(value, opts = {}) {
  const v = Number(value || 0);
  if (!isFinite(v) || v === 0) return "$0";
  const compact = opts.compact !== false;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: compact && Math.abs(v) >= 1000 ? "compact" : "standard",
    maximumFractionDigits: 2,
  }).format(v);
}

export function formatNumber(value, opts = {}) {
  const v = Number(value || 0);
  if (!isFinite(v)) return "-";
  const compact = opts.compact !== false && Math.abs(v) >= 1000;
  return new Intl.NumberFormat("en-US", {
    notation: compact ? "compact" : "standard",
    maximumFractionDigits: opts.maxFraction ?? 2,
  }).format(v);
}

export function formatPct(value, digits = 2) {
  const v = Number(value || 0);
  if (!isFinite(v)) return "-";
  return `${v.toFixed(digits)}%`;
}

export function timeAgo(unix) {
  if (!unix) return "-";
  const now = Math.floor(Date.now() / 1000);
  const diff = Math.max(0, now - unix);
  const units = [
    [60, "second"],
    [60, "minute"],
    [24, "hour"],
    [30, "day"],
    [12, "month"],
    [Number.POSITIVE_INFINITY, "year"],
  ];
  let value = diff;
  let unit = "second";
  for (const [step, name] of units) {
    if (value < step) { unit = name; break; }
    value = value / step;
    unit = name;
  }
  const rounded = Math.round(value);
  return `${rounded} ${unit}${rounded !== 1 ? "s" : ""} ago`;
}
